
import './styles.css';
import { useHistory } from "react-router-dom";

function Maintenance() {

    const history = useHistory();

    return (
        <div className="content-menu">
            <div className="box-menu" onClick={() => history.push({ pathname: "/d-rec-admin/main/maintenance/dashboard" })}>
                <div className="content" style={{ backgroundColor: "rgb(203, 174, 202)" }}>
                    <div className="shot-name">RMT</div>
                    <div className="full-name">Result MT</div>
                    <div className="line"></div>
                    <div className="note">Looking Result of Maintenance</div>
                </div>
            </div>
            {/* <div className="box-menu" onClick={() => history.push({ pathname: "/d-rec-admin/main/maintenance/result-mt" })}>
                <div className="content" style={{ backgroundColor: "rgb(203, 174, 202)" }}>
                    <div className="shot-name">RMT</div>
                    <div className="full-name">Result MT</div>
                    <div className="line"></div>
                    <div className="note">Looking Result of Maintenance</div>
                </div>
            </div> */}
            <div className="box-menu" onClick={() => history.push({ pathname: "/d-rec-admin/main/maintenance/standard-gas" })}>
                <div className="content" style={{ backgroundColor: "rgb(207, 246, 175)" }}>
                    <div className="shot-name">SG</div>
                    <div className="full-name">Standard Gas</div>
                    <div className="line"></div>
                    <div className="note">Standard Gas management of Maintenance</div>
                </div>
            </div>
            <div className="box-menu" onClick={() => history.push({ pathname: "/d-rec-admin/main/maintenance/standard-type" })}>
                <div className="content" style={{ backgroundColor: "rgb(118, 246, 230)" }}>
                    <div className="shot-name">ST</div>
                    <div className="full-name">Standard Type</div>
                    <div className="line"></div>
                    <div className="note">Standard Type management of Maintenance</div>
                </div>
            </div>
        </div>
    );
}

export default Maintenance;